export default "__VITE_ASSET__DH$8WWiR__"